import axios from 'axios'
import config from '@/config'
import json from '@/service/jsonPrototype.service'
import { hasOwnProp } from '@/utils'
import { getCookie } from 'tiny-cookie'

/**
 * Create new Instance.
 */
const instance: any = axios.create({
  baseURL: config.APP_API
})

/**
 * Verify auth-token cookies.
 */
const cookie: any = json.decrypt(getCookie(config.APP_AUTH))
if (cookie && hasOwnProp(cookie, 'accessToken')) {
  instance.defaults
    .headers
    .Authorization = cookie.accessToken
}

export default instance